import styled from 'styled-components';

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0px 5px;
  justify-content: center;
  align-items: center;

  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
`;

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black5};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const DescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black5};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;
